import { send } from 'server';

export const fetchConfiguration = (type = [0, 1, 2, 3, 4, 5, 6, 7]) => send({
    ID: 32942,
    responses: [32943, 32944],
    description: 'Get Responsible Gaming Configuration',
    type
});
